import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CompletedOnboardingGuard } from './guards/completed-onboarding.guard';
import { OnboardingUserGuard } from './guards/onboarding-user.guard';
import { OnboardingDataDispatcher } from './onboarding-data.dispatcher';
import { OnboardingDataEffects } from './onboarding-data.effects';
import { FEATURE_NAME, reducer } from './onboarding-data.reducer';
import { OnboardingDataService } from './onboarding-data.service';
import { OnboardingDataStore } from './onboarding-data.store';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([OnboardingDataEffects]),
    StoreModule.forFeature(FEATURE_NAME, reducer),
  ],
  declarations: [],
})
export class OnboardingDataModule {
  static forRoot(): ModuleWithProviders<OnboardingDataModule> {
    return {
      ngModule: OnboardingDataModule,
      providers: [
        OnboardingDataService,
        OnboardingDataStore,
        OnboardingDataDispatcher,
        OnboardingUserGuard,
        CompletedOnboardingGuard,
      ],
    };
  }
}
